import React, { useMemo } from 'react';
import { useStoreon } from 'storeon/react';
import { MODEL_JSON_STORE_NAME, selectSeoProperties } from 'modules/model-json';
import { COLLECTIONS_STORE_NAME, selectPriceFacet } from 'modules/collections';
import { State } from 'store/types';

export const ProductSchema: React.FC = () => {
  const { modelJson } = useStoreon<State>(MODEL_JSON_STORE_NAME);
  const { collections } = useStoreon<State>(COLLECTIONS_STORE_NAME);
  const seoProperties = useMemo(() => selectSeoProperties(modelJson), [modelJson]);
  const priceFacet = selectPriceFacet(collections);

  if (!priceFacet) {
    return null;
  }

  return (
    <div itemScope itemType="https://schema.org/Product">
      <meta itemProp="name" content={seoProperties?.h1 ?? undefined} />
      <meta itemProp="description" content={seoProperties?.metadescription ?? undefined} />
      <div itemProp="offers" itemScope itemType="https://schema.org/AggregateOffer">
        {priceFacet &&
          priceFacet.values.map(({ name, value }) => (
            <meta
              content={value.toString()}
              itemProp={name === 'minPrice' ? 'lowPrice' : 'highPrice'}
              key={name}
            />
          ))}
        <meta itemProp="offerCount" content={collections.productsCount.toString()} />
        <meta itemProp="priceCurrency" content="RUB" />
      </div>
    </div>
  );
};
